(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedFrequencyTo', MedFrequencyTo);

    MedFrequencyTo.$inject = ['$resource'];

    function MedFrequencyTo ($resource) {
        var resourceUrl =  'api/med-frequency-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
